/**
 * Resource danh mục nhóm tài khoản
 * ndquang1 16.5.2024
 */
export default {
  Title: 'Nhóm tài khoản',
  Code: 'Mã số *',
  CodeTitle: 'Mã số',
  Name: 'Tên nhóm tài khoản *',
  NameTitle: 'Tên nhóm tài khoản',
  DetailByObject: 'Chi tiết theo đối tượng',
  DetailByObjectDecision: 'Chi tiết theo đối tượng và quyết định',
  NotDetail: 'Không theo dõi chi tiết',
  DetailByBank: 'Chi tiết theo tài khoản ngân hàng, kho bạc',
  Kind: 'Tính chất',
  Description: 'Ghi chú',

  InitialBalanceAriseTitle: 'Tài khoản đã có số dư ban đầu',
  InitialBalanceAriseContent: `Không đổi được thuộc tính {0} vì tài khoản {1} đã có số dư ban đầu!`,
};
